const AppRoutes = {
  home: '/',

  login: '/login',
  register: '/register',
  resetPassword: '/reset-password',

  survey: '/survey',
  surveyCreate: '/survey/create',
  surveyEdit: '/survey/edit/:id',
  surveyEditFn: (id) => `/survey/edit/${id}`,
  surveyView: '/survey/view/:id',
  surveyViewFn: (id) => `/survey/view/${id}`,

  report: '/report',
  reportView: '/report/view/:id',
  reportViewFn: (id) => `/report/view/${id}`,
  reportSDQ: '/report/sdq/:id',
  reportSDQFn: (id) => `/report/sdq/${id}`,

  users: '/users',
  usersDetail: '/users/:id',
  usersDetailFn: (id) => `/users/${id}`,
  usersDetailFnHash: (id) => `/users/${id}`,

  evaluationAnalysis: '/evaluation-analysis',

  sampleVideoAse: '/sample-video-ase',
  sampleVideoDay: '/sample-video-day',

  chat: '/chat',
  chats: '/chats',

  facility: '/facility',
};

export default AppRoutes;
